import type { PageableContent } from '@/types'

export const fetchAllPages = async <T>(
  fetchPage: (page: number) => Promise<PageableContent<T>>
): Promise<T[]> => {
  const firstPage = await fetchPage(0)
  const restPageNumbers = Array.from(
    { length: Math.max(firstPage.totalPages - 1, 0) },
    (_, index) => index + 1
  )
  const restPages = await Promise.all(restPageNumbers.map(fetchPage))
  return [firstPage, ...restPages].flatMap((page) => page.content)
}
